// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable no-param-reassign */
import JSONSerializer from '@ember-data/serializer/json';
import { inject as service } from '@ember/service';
import { EmbeddedRecordsMixin } from '@ember-data/serializer/rest';
import { underscore } from '@ember/string';

// eslint-disable-next-line ember/no-classic-classes
export default JSONSerializer.extend(EmbeddedRecordsMixin, {
  attrs: {
    plan: {
      key: 'plan_id',
      serialize: 'id',
      deserialize: 'id'
    },
    planVariation: {
      key: 'plan_variation_id',
      serialize: 'id',
      deserialize: 'id'
    },
    lastInvoice: {
      key: 'last_invoice_id',
      serialize: 'id',
      deserialize: 'id'
    },
    actions: {
      embedded: 'always'
    },
    phases: {
      embedded: 'always'
    },
    source: {
      embedded: 'always'
    }
  },
  features: service,
  keyForAttribute(attr) {
    return underscore(attr);
  },
  modelNameFromPayloadKey(payloadKey) {
    if (payloadKey === 'subscriptions') {
      return this._super('buyer-sub');
    } else {
      return this._super(payloadKey);
    }
  },
  normalize(typeClass, hash) {
    if (hash['subscription_status']) {
      hash['status'] = hash['subscription_status'];
      delete hash['subscription_status'];
    }
    if (hash['price_override']) {
      hash['price_override_money'] = hash['price_override'];
      delete hash['price_override'];
    }
    if (hash['subscription_id']) {
      hash['id'] = hash['subscription_id'];
      delete hash['subscription_id'];
    }
    if (hash['invoice_ids']) {
      hash['last_invoice_id'] = hash['invoice_ids'][0];
    }
    return this._super(typeClass, hash);
  },
  // We don't want to replace the subId with a temporary Id.
  normalizeSingleResponse(store, primaryModelClass, payload, id, requestType) {
    const subId = payload.subscription.id;
    if (!payload.subscription.id || !subId && subId.charAt(0) === '#') {
      payload.subscription.id = id;
    }
    return this._super(store, primaryModelClass, payload.subscription, id, requestType);
  },
  normalizeArrayResponse(store, primaryModelClass, payload, id, requestType) {
    const newPayload = payload.subscriptions || [];
    newPayload.cursor = payload.cursor;
    return this._super(store, primaryModelClass, newPayload, id, requestType);
  },
  extractMeta(store, typeClass, payload) {
    if (payload && Object.prototype.hasOwnProperty.call(payload, 'cursor')) {
      const meta = {
        cursor: payload.cursor
      };
      delete payload.cursor;
      return meta;
    }
    return null;
  },
  serialize(snapshot, options) {
    const json = this._super(snapshot, options);
    delete json.last_invoice_id;
    return json;
  },
  serializeAttribute(snapshot, json, key, attribute) {
    // Do not transform enums
    if (attribute.type === 'enum') {
      json[key] = snapshot.attr(key);
      return;
    }
    if (!snapshot.record.isNew && attribute.options.readOnly) {
      return;
    }
    if (snapshot.record.isNew && attribute.options.excludeFromCreate) {
      return;
    }
    this._super(snapshot, json, key, attribute);
  }
});